/* eslint-disable no-nested-ternary */
import classNames from 'classnames';
import React, { forwardRef, HTMLAttributes } from 'react';

// import { Action, Handle, Remove } from '../../../../components';
import { PsTreeItem } from '../../../../../../../../api/model';
import { getIconImageFilePaths } from '../../../PsTreeNode';
import { Action, Handle, Remove } from '../Item';
import styles from './TreeItem.module.scss';

export interface Props extends Omit<HTMLAttributes<HTMLLIElement>, 'id'> {
  childCount?: number;
  clone?: boolean;
  collapsed?: boolean;
  depth: number;
  disableInteraction?: boolean;
  disableSelection?: boolean;
  ghost?: boolean;
  handleProps?: any;
  indicator?: boolean;
  indentationWidth: number;
  // value: string;
  psTreeItem: PsTreeItem;
  languageId: number;
  disabled?: boolean | undefined;
  isTarget?: boolean | undefined;
  onCollapse?(): void;
  onRemove?(): void;
  wrapperRef?(node: HTMLLIElement): void;
}

export const TreeItem = forwardRef<HTMLDivElement, Props>(
  (
    {
      childCount,
      clone,
      depth,
      disableSelection,
      disableInteraction,
      ghost,
      handleProps,
      indentationWidth,
      indicator,
      collapsed,
      onCollapse,
      onRemove,
      style,
      // value,
      psTreeItem,
      languageId,
      disabled,
      isTarget,
      wrapperRef,
      ...props
    },
    ref
  ) => (
    <li
      className={
        classNames(
          styles.Wrapper,
          clone && styles.clone,
          ghost && styles.ghost,
          indicator && styles.indicator,
          disableSelection && styles.disableSelection,
          disableInteraction && styles.disableInteraction
        )
      }
      ref={wrapperRef}
      style={
        {
          '--spacing': `${indentationWidth * depth}px`,
          // marginLeft: `${indentationWidth * depth}px`,
          // width: '400px',
        } as React.CSSProperties
      }
      {...props}
    >
      <div className={styles.TreeItem} ref={ref} style={style}>
        {
          // disabled なら <Handle /> を表示しない。
          (!disabled)
          &&
          (
            <Handle {...handleProps} />
          )
        }
        {
          (onCollapse)
          &&
          (
            <Action
              onClick={onCollapse}
              className={
                classNames(
                  styles.Collapse,
                  collapsed && styles.collapsed
                )
              }
            >
              {collapseIcon}
            </Action>
          )
        }
        {/* 
          <span className={styles.Text}>
            {value}
          </span> 
        */}

        <span
          // className='psTreeItemContentsSpan'
          style={{
            // cursor: 'pointer',
            backgroundColor: (
              (isTarget) ?
                // 編集対象の PS ツリー アイテムの背景色。
                '#FFEEDD'
                :
                (
                  // 編集対象以外の PS ツリー アイテムの背景色。

                  // 改廃案状態の PS は、背景色 (グレー) が付く。
                  (psTreeItem.temp_flag) ?
                    'Gainsboro'
                    :
                    (
                      // PS 閲覧 の表示オプションで「PS 状態」の中に「廃止済み」というチェックボックスがあり、チェックすると廃止にした PS をツリーに表示することが出来る。
                      // deleted_flag が 1 の時はツリー アイテムの背景色を赤色にする。
                      (psTreeItem.deleted_flag) ?
                        'OrangeRed'
                        :
                        'initial'
                    )
                )
            ),
          }}
        >

          {
            (psTreeItem.type !== 3)
            &&
            (depth !== 0)
            &&
            (
              <span
                className='mkn'
              // style={{
              //   width: '1rem',
              //   color: '#c21413',
              //   fontWeight: 'bold',
              //   marginLeft: '0.25rem',
              // }}
              >
                {psTreeItem.level}
              </span>
            )
          }

          <span>
            {
              getIconImageFilePaths(psTreeItem).map(
                (iconImageFilePath: string) =>
                  <img
                    key={iconImageFilePath}
                    alt='icon'
                    style={{ width: '1rem' }}
                    src={iconImageFilePath}
                  />
              )
            }
          </span>

          {/* テキスト。 */}
          <span
            style={{
              // search_result が true の時は通常の文字色、false の時はグレーの文字色で表示する。
              color: (psTreeItem.search_result) ? '#333333' : 'LightGray',
            }}
          >
            {
              (psTreeItem.titles)
              &&
              (psTreeItem.titles[languageId])
            }
          </span>
        </span>

        {
          (!clone)
          &&
          (onRemove)
          &&
          (
            <Remove onClick={onRemove} />
          )
        }
        {
          (
            (clone)
            &&
            (childCount)
            &&
            (childCount > 1)
          )
          &&
          (
            <span className={styles.Count}>{childCount}</span>
          )
        }
      </div>
    </li>
  )
);

TreeItem.defaultProps = {
  childCount: undefined,
  clone: undefined,
  collapsed: undefined,
  disableInteraction: undefined,
  disableSelection: undefined,
  ghost: undefined,
  handleProps: undefined,
  indicator: undefined,
  onCollapse: undefined,
  onRemove: undefined,
  wrapperRef: undefined,
};

const collapseIcon = (
  <svg width="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 41">
    <path d="M30.76 39.2402C31.885 40.3638 33.41 40.995 35 40.995C36.59 40.995 38.115 40.3638 39.24 39.2402L68.24 10.2402C69.2998 9.10284 69.8768 7.59846 69.8494 6.04406C69.822 4.48965 69.1923 3.00657 68.093 1.90726C66.9937 0.807959 65.5106 0.178263 63.9562 0.150837C62.4018 0.123411 60.8974 0.700397 59.76 1.76024L35 26.5102L10.24 1.76024C9.10259 0.700397 7.59822 0.123411 6.04381 0.150837C4.4894 0.178263 3.00632 0.807959 1.90702 1.90726C0.807714 3.00657 0.178019 4.48965 0.150593 6.04406C0.123167 7.59846 0.700153 9.10284 1.75999 10.2402L30.76 39.2402Z" />
  </svg>
);

TreeItem.defaultProps = {
  disabled: undefined,
  isTarget: undefined,
};